module.exports = __webpack_public_path__ + "static/media/1033159.d5182db7.jpg";